const PAGES = {
    HOME: {
        slug: 'kalvium',
        title: 'Kalvium',
    },
    LIVEBOOKS: {
        slug: 'livebooks',
        title: 'Kalvium Livebooks',
    },
    DOJO: {
        slug: 'dojo',
        title: 'Kalvium Dojo',
    },
}

export default PAGES
